import React from 'react';
import { PhoneList } from '../../../../../components/PhoneList/PhoneList';

export const DoctorRegistry = ({ showRegistry }) => {
    return (!!showRegistry && <PhoneList label="Номера регистратуры"/>);
};
